module.exports = __webpack_public_path__ + "a0e9de675daeaaaf80735aa9ccf3312d.png";